import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          分类索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按类型快速发现你想看的漫画，40+ 细分标签等你探索
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group flex items-start gap-4 bg-background-50 rounded-xl border border-background-200/70 p-5 cursor-pointer transition-all duration-200 hover:border-primary-300 hover:bg-background-50"
            >
              <div className="w-11 h-11 flex-shrink-0 rounded-xl bg-primary-100 flex items-center justify-center text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                <i className={`${item.icon} text-xl`} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mb-1.5">{item.desc}</p>
                <span className="text-xs text-primary-500 font-medium">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}